import { render, staticRenderFns } from "./section-oxygen-minus-event-table.vue?vue&type=template&id=1fe3ddc6&scoped=true"
import script from "./section-oxygen-minus-event-table.vue?vue&type=script&lang=js"
export * from "./section-oxygen-minus-event-table.vue?vue&type=script&lang=js"
import style0 from "./section-oxygen-minus-event-table.vue?vue&type=style&index=0&id=1fe3ddc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe3ddc6",
  null
  
)

export default component.exports